export default "<app-editor></app-editor>\r\n\r\n"